import styled from 'styled-components';
import { getSpace, mq, px2rem } from '@stylesheets/tools';

const StyledEducationTopicFilter = styled.div`
  padding-top: ${getSpace('l')};

  .topic-filter {
    padding: ${getSpace('l')} 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${px2rem('18px')};

    ${mq('l')} {
      padding: ${getSpace('xl')} 0;
      gap: ${px2rem('20px')};
    }

    .refinement__headline {
      font-size: ${px2rem('22px')};

      ${mq('l')} {
        font-size: ${px2rem('28px')};
      }
    }
    .refinement__grid {
      justify-content: center;

      .filter-tag .filter-tag__title {
        font-size: ${px2rem('18px')};

        ${mq('l')} {
          font-size: ${px2rem('22px')};
        }
      }
    }
  }
`;

export default StyledEducationTopicFilter;
